import React from 'react';
import UsageHistory from './UsageHistory';
import { connect } from 'react-redux';
import { fetchUsageHistoryChartData } from '../../../../dataFetchers/usageDataFetcher';
import { getBECompatibleFuelType } from '../../../../helpers/helper';
import { TIMESCALE } from '../../../../constants/common';

class UsageHistoryContainer extends React.Component {
  componentDidMount(){
    if(!this.props.chartData.seriesData) {
      let params = {
        'measurement-type': getBECompatibleFuelType(this.props.configs.data['fuelType']),
        mode : TIMESCALE.YEAR.toLowerCase(),
        'skip-itemization':true,
        'skip-ongoing-cycle':true,
        'date-format' : this.props.configs.data["DASHBOARD.USAGE_CHART.DATE_FORMAT"]
      }
      this.props.fetchChartData(this.props.userId, params);
    }
  }
  render(){
    return(
      <>
        {(this.props.chartData.seriesData || this.props.chartData.error) && <UsageHistory chartData={this.props.chartData.seriesData} translations={this.props.translations} chartDataError={this.props.chartData.error} configs={this.props.configs}/>}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId : state.userIdentityDetails.userId,
    chartData : state.usageHistoryData,
    translations: state.translationsData,
    configs : state.configs
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchChartData : (uuid, params) => {dispatch(fetchUsageHistoryChartData(uuid, params))}
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UsageHistoryContainer);